import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeLoginComponent implements OnInit {
  constructor() { }

  ngOnInit() {
    sessionStorage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home-login/home.component.ts